import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  Container,
  Grid,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { useMyRequests } from './useRequests';
import { RequestCard } from './RequestCard';

export function MyRequestsPage() {
  const { t } = useTranslation();
  const { requests, isLoading } = useMyRequests();

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 3, md: 5 } }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        alignItems={{ sm: 'flex-end' }}
        justifyContent="space-between"
        sx={{ mb: 4 }}
      >
        <Box>
          <Typography variant="h3" sx={{ mb: 0.5 }}>
            {t('requests.myTitle')}
          </Typography>
          <Typography color="text.secondary">{t('requests.mySubtitle')}</Typography>
        </Box>
        <Button
          component={RouterLink}
          to="/requests/new"
          variant="contained"
          startIcon={<AddRoundedIcon />}
        >
          {t('requests.postAction')}
        </Button>
      </Stack>

      {isLoading ? (
        <Grid container spacing={2}>
          {Array.from({ length: 3 }).map((_, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Skeleton variant="rounded" height={220} />
            </Grid>
          ))}
        </Grid>
      ) : requests.length === 0 ? (
        <Box sx={{ textAlign: 'center', py: 6 }}>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            {t('requests.myEmpty')}
          </Typography>
          <Button
            component={RouterLink}
            to="/requests/new"
            variant="contained"
            startIcon={<AddRoundedIcon />}
          >
            {t('requests.postAction')}
          </Button>
        </Box>
      ) : (
        <Grid container spacing={2}>
          {requests.map((r) => (
            <Grid item xs={12} sm={6} md={4} key={r.id}>
              <RequestCard request={r} />
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
}
